import { useState } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { Button } from "../../../components";
import { URL_PARAMS } from "../../../../constants";
import "../../../../DualAssesment/DualAssessmentToast.scss";
import "./styles.scss";

interface SaveButtonProps {
  onSave?: () => void;
  disabled?: boolean;
}

export function SaveButton({ onSave, disabled }: SaveButtonProps) {
  const { search } = useLocation();
  const [saved, setSaved] = useState(false);

  const show =
    new URLSearchParams(search).get(URL_PARAMS.USE_ATTRS_AS_SESSION) === "1";

  if (!show) return null;

  function handleSave() {
    onSave?.();
    setSaved(true);
    toast.success("Data successfully saved", { className: "das-toast" });
    setTimeout(() => setSaved(false), 2000);
  }

  return (
    <div className="save-button-container">
      <Button
        onClick={handleSave}
        large
        {...({
          className: "tg_button tg_btn-large save-button",
          disabled: saved || disabled,
        } as object)}
      >
        Save
      </Button>
    </div>
  );
}
